export interface IAutoLinkTextProps {
    /** Текст */
    text?: string;
    /**
     * Показать текст как есть, без ссылок (напр. предпросмотр документа для поддержки).
     * @default false
     */
    disableLinks?: boolean;
}

const AutoLinkText: React.FC<IAutoLinkTextProps> = ({ text, disableLinks = false }: IAutoLinkTextProps) => {
    if (disableLinks) {
        return <>{text}</>;
    }

    // метка домена перед точкой обязательна: иначе «.<br» из разметки конфигурации сходит за адрес
    const delimiter =
        /((?:https?:\/\/)?(?:(?:[a-z0-9](?:[a-z0-9\-]{0,61}[a-z0-9])?\.)+[a-z]{2,}|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(?::\d{1,5})*[a-z0-9.,_\/~#&=;%+?\-\\(\\)]*)/gi;

    return (
        <>
            {text?.split(delimiter).map((word, index) => {
                const match = word.match(delimiter);
                if (match) {
                    const url = match[0];
                    return (
                        <a
                            key={index}
                            href={url.startsWith('http') ? url : `http://${url}`}
                            target="_blank"
                            rel="noopener,noreferrer"
                        >
                            {url}
                        </a>
                    );
                }
                return word;
            })}
        </>
    );
};

export default AutoLinkText;
